import * as moment from 'moment-timezone';

export const DisplayDate = (date: string): string => {
    return moment(date).tz('America/Los_Angeles').format('MMM DD YYYY')
}
